import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12 order-xl-1" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Management Document")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_7 = { class: "is-mobile" }
const _hoisted_8 = { class: "d-flex m-3 pb-2" }
const _hoisted_9 = { class: "is-web" }
const _hoisted_10 = { class: "d-flex justify-content-end m-3 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentComponent = _resolveComponent("DocumentComponent")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", null, [
            _createVNode(_component_DocumentComponent, {
              modelValue: _ctx.document,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_n_button, {
                  class: "mr-3 flex-fill",
                  type: "primary",
                  onClick: _ctx.save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SAVE ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_n_button, {
                  class: "flex-fill",
                  strong: "",
                  secondary: "",
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" BACK ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_n_button, {
                  class: "mr-3",
                  type: "primary",
                  onClick: _ctx.save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SAVE ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_n_button, {
                  class: "",
                  strong: "",
                  secondary: "",
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" BACK ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}